module.exports = __webpack_public_path__ + "img/full-time.b5e55086.svg";